import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "コンタクトレンズを簡単に注文できるスマホアプリを開発いたしました。このアプリは、ユーザー体験に重点を置き、アプリを開いてすぐに購入できるような、PUSH通知からのシナリオを描いた導線設計やUI設計を行いました。弊社はウォークスルーのイラスト・アニメーションからアプリの開発まで実施しました。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const visionaryholdingsPageMeta: PageMeta = {
  title: "コンタクトレンズが簡単注文できるアプリ | 事例 | i3DESIGN アイスリーデザイン",
  description,
  keyword: "flamingo UIUX モダナイゼーション JavaScript ウェブシステム",
  image: primaryImage,
  url: `${SITE_URL}/cases/visionaryholdings/`,
}

export const visionaryholdingsSchema = buildCaseStudySchema({
  slug: "visionaryholdings",
  pageTitle: visionaryholdingsPageMeta.title,
  description: visionaryholdingsPageMeta.description,
  headline: "コンタクトレンズが簡単注文できるアプリ",
  alternativeHeadline: "株式会社ビジョナリーホールディングス",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/caseStudyTop/visionaryholdings.webp"],
  clientName: "株式会社ビジョナリーホールディングス",
  breadcrumbLabel: "コンタクトレンズが簡単注文できるアプリ",
})
